import { useQuery } from "@tanstack/react-query";
import { getPriceListByDirection } from "../priceList";

export function usePriceListByDirection(directionKey: string | null) {
  return useQuery({
    queryKey: ["priceList", "byDirection", directionKey],
    queryFn: () => getPriceListByDirection(directionKey as string),
    enabled: Boolean(directionKey),
    staleTime: 60_000,
  });
}